export default __webpack_public_path__ + "static/media/features-left-triangle.1eaaace3.png";